import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { LuGlobe, LuMapPin } from 'react-icons/lu';

// Local = delivered inside Vietnam, Oversea = everywhere else — decided on the
// API from the project location (Crm::Logistic::ShipScope). A user may be
// limited to one of them (HSO sees Local only, the Oversea team Oversea only).
export const SHIP_SCOPES = ['local', 'oversea'];

export const SHIP_SCOPE_LABELS = {
  local: 'Local (Vietnam)',
  oversea: 'Oversea',
};

const STYLES = {
  local: { cls: 'tw-bg-emerald-50 tw-text-emerald-700 tw-border-emerald-200', icon: LuMapPin },
  oversea: { cls: 'tw-bg-indigo-50 tw-text-indigo-700 tw-border-indigo-200', icon: LuGlobe },
};

// Scopes the signed-in user may see. Profiles loaded before the field existed
// carry none — treat that as "both" so nobody's view collapses until reload.
export const useShipScopes = () => {
  const scopes = useSelector((state) => state.profile_user?.data?.logistic_ship_scopes);
  return Array.isArray(scopes) && scopes.length > 0 ? scopes : SHIP_SCOPES;
};

// "All / Local / Oversea" options for a SegmentedControl; empty value = all.
export const shipScopeOptions = () => [
  { value: '', label: 'All' },
  ...SHIP_SCOPES.map((scope) => ({ value: scope, label: SHIP_SCOPE_LABELS[scope] })),
];

export const ShipScopeBadge = ({ scope, className = '' }) => {
  const style = STYLES[scope];
  if (!style) return null;
  const Icon = style.icon;

  return (
    <span
      className={`tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-border tw-border-solid ${style.cls} ${className}`}
    >
      <Icon size={11} aria-hidden="true" />
      {SHIP_SCOPE_LABELS[scope]}
    </span>
  );
};

ShipScopeBadge.propTypes = {
  scope: PropTypes.string,
  className: PropTypes.string,
};
